var isabella = isabella || {};
isabella.club = {
    init: function () {
        jQuery.when.apply( jQuery, [
            e4.util.require.js( e4.settings.require.jQueryValidate ),
            e4.util.require.js( e4.settings.require.datepicker )
        ] ).then( function () {
            isabella.club.bindDatePicker();
            isabella.club.hideTentInfo();
            isabella.club.bindEvents();
        } );
        // ADD MORE THAN ONE TENT AND REMOVE TENTS
    },
    bindEvents: function () {
        jQuery( '.js-isabella-club-signup-form' ).validate( {
            submitHandler: function ( domForm ) {
                if( jQuery( domForm ).find( 'input#url' ).val().length === 0 )
                {
                    jQuery( domForm ).attr( 'action', location.href );
                    domForm.submit();
                }
            }
        } )
        // Click add tent and show next tent also remove the clicked add-tent button
        jQuery( '.tent-info-add-tent' ).on( 'click', function () {
            jQuery( this ).closest( '.tent-info' ).next().fadeIn( 500 );
            jQuery( this ).hide();
            return false;
        } );
        // Click remove this tent and clear fields and hide the tent. Also add the "add tent" button back to the
        // previous tent.
        jQuery( '.tent-info-remove-tent' ).on( 'click', function () {
            jQuery( this ).closest( '.tent-info' ).fadeOut( 500 );
            jQuery( this ).closest( '.tent-info' ).find( 'input, select' ).val( '' );
            jQuery( this ).closest( '.tent-info' ).prev().find( '.tent-info-add-tent' ).show();
            return false;
        } );
        jQuery( '#usermanagement-createuser-profile-button' ).on( 'click', isabella.club.postRegFormToServer );
        jQuery( '#usermanagement-usersignup-button' ).on( 'click', isabella.club.postRegFormToServer );
        //if the user check the "Is not camper" checkbox, remove the last section
        jQuery( '#checkboxChoice5' ).on( 'change', function () {
            if ( this.checked ) {
                //Do stuff
                jQuery( '#tentInfoDiv' ).hide();
                jQuery( '#inputSize' ).removeClass( 'required' );
                jQuery( '#inputYear' ).removeClass( 'required' );
                jQuery( 'inputBuydate' ).removeClass( 'required' );
                jQuery( '#inputDealer' ).removeClass( 'required' );
            }
            if ( this.checked === false ) {
                jQuery( '#tentInfoDiv' ).show();
                jQuery( 'inputSize' ).addClass( 'required' );
                jQuery( '#inputYear' ).addClass( 'required' );
                jQuery( '#inputBuydate' ).addClass( 'required' );
                jQuery( '#inputDealer' ).addClass( 'required' );
            }
        } );
        // Hide tents when clicking No Isabella Tent or Tent Of Other Brand
        jQuery( '.js-no-tent' ).on( 'change', function () {
            if ( jQuery( '.js-no-tent' ).is( ':checked' ) ) {
                //jQuery( '.js-other-brand-field' ).show();
                jQuery( '#tentInfoDiv' ).hide();
                jQuery( '#selectModel' ).removeClass( 'required' );
                jQuery( '#inputSize' ).removeClass( 'required' );
                jQuery( '#inputYear' ).removeClass( 'required' );
                jQuery( '#inputBuydate' ).removeClass( 'required' );
                jQuery( '#inputDealer' ).removeClass( 'required' );
            }
            else {
                //jQuery( '.js-other-brand-field' ).hide();
                //jQuery( '.js-other-brand-field input' ).val( '' );
                jQuery( '#tentInfoDiv' ).show();
                jQuery( '#selectModel' ).addClass( 'required' );
                jQuery( '#inputSize' ).addClass( 'required' );
                jQuery( '#inputYear' ).addClass( 'required' );
                jQuery( '#inputBuydate' ).addClass( 'required' );
                jQuery( '#inputDealer' ).addClass( 'required' );
            }
        } );
        /*
        jQuery( '.js-otherbrand' ).on( 'change', function () {
            if ( jQuery( '.js-no-tent' ).is( ':checked' ) ) {
                jQuery( '.js-other-brand-field' ).show();
            }
            else {
                jQuery( '.js-other-brand-field' ).hide();
            }
        } );
        */
         
        // Show/hide tents when you click "ikke campist"
        jQuery( '.js-ikkecampist' ).on( 'click', function () {
            jQuery( '.js-tents' ).toggle();
            jQuery( '.js-tents' ).find( 'input, select' ).val( '' );
        } );
    },
    hideTentInfo: function () {
        jQuery( '.tent-info' ).each( function () {
            // Hide all tents that are empty
            var inputValue = jQuery( this ).find( 'input' );
            if ( inputValue.val() === '' ) {
                jQuery( this ).hide();
            }
            //hide add button if next tent is not empty
            var nextInputValue = jQuery( this ).next().find( 'input' );
            if ( nextInputValue.val() !== '' ) {
                jQuery( this ).find( '.tent-info-add-tent' ).hide();
            }
        } );
        // Dont' hide the first tent
        jQuery( '.tent-info:first' ).show();
        // Hide tent-info on viewpage if all fields are empty
        jQuery( '.view-tent-info' ).each( function () {
            var ddValue = jQuery( this ).find( 'dd' );
            if ( jQuery.trim( ddValue.text() ) === '' ) {
                jQuery( this ).hide();
            }
        } );
    },
    bindDatePicker: function () {
        $( '#datePicker' ).datepicker( {
            format: 'dd-mm-yyyy'
        } );
        $( '#datePicker2' ).datepicker( {
            format: 'dd-mm-yyyy'
        } );
        $( '#datePicker3' ).datepicker( {
            format: 'dd-mm-yyyy'
        } );
        $( '#datePicker4' ).datepicker( {
            format: 'dd-mm-yyyy'
        } );
        $( '#datePicker5' ).datepicker( {
            format: 'dd-mm-yyyy'
        } );
        $( '#datePicker6' ).datepicker( {
            format: 'dd-mm-yyyy'
        } );
    },
    postRegFormToServer: function () {
        var username = jQuery( '#inputEmail' ).val();
        var somethingRandom = isabella.club.generateRandom();
        jQuery( '#hiddenUserName' ).val( username );
        jQuery( '#UserManagement_Form_NewPassword' ).val( somethingRandom );
        jQuery( '#UserManagement_Form_NewPasswordConfirm' ).val( somethingRandom );
    },
    generateRandom: function () {
        var somethingRandom = Math.random().toString( 36 ).slice( -8 );
        return somethingRandom;
    }
};
